import {
    DRAWER,
    SALES_DRAWER,
} from '../constants/index';


export function switchSalesView(data) {
    return {
        type: SALES_DRAWER,
        payload:{
            view: data.target.textContent
        },

    };
}

export function switchMenu(data) {
    return {
        type: DRAWER,
        payload:{
            openMenu: data
        },

    };
}



// WEBPACK FOOTER //
// ./src/actions/sales.js